export let kpp_1_2 = {
	"name": "kpp_1_2",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Прогноз криминологический",
	"data": {
		"questions": [
			{
				"qst": "Выберите привильное определение понятия «прогноз криминологический»",
				"correct_ans": [
					{
						"ans": "Научно обоснованное вероятностное суждение о будущем состоянии, тенденциях, периодах развития преступности, личности преступника, факторов, последствий и мер борьбы с преступностью",
						"score": 10
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ неточный. Криминологический прогноз - научно обоснованное вероятностное суждение о будущем состоянии, тенденциях, периодах развития преступности, личности преступника, факторов, последствий и мер борьбы с преступностью.",
						"ans": "Научно обоснованное суждение о будущем состоянии, тенденциях, периодах развития преступности, личности преступника, причин и условий преступности, системы мер борьбы с преступностью, последствий преступности",
						"score": 0
					},
					{
						"comm": "Описание свойств, закономерностей, факторов и последствий преступности, а также свойств личности преступника - криминологическая характеристика.",
						"ans": "Описание свойств, закономерностей, факторов и последствий преступности, а также свойств личности преступника",
						"score": -5
					},
					{
						"comm": "Ответ неточный. Криминологический прогноз - Научно обоснованное вероятностное суждение о будущем состоянии, тенденциях, периодах развития преступности, личности преступника, факторов, последствий и мер борьбы с преступностью.",
						"ans": "Вероятностное суждение о будущем состоянии, тенденциях, периодах развития преступности, личности преступника, причин и условий преступности, системы мер борьбы с преступностью, последствий преступности",
						"score": 0
					},
					{
						"comm": "Процесс или результат оценки специалистами характера и степени влияния исследуемого объекта на преступность,личность преступника, факторы и последствия преступности, а также систему мер борьбы с преступностью - криминологическая экспертиза.",
						"ans": "Процесс или результат оценки специалистами характера и степени влияния исследуемого объекта на преступность,личность преступника, факторы и последствия преступности, а также систему мер борьбы с преступностью",
						"score": -5
					},
					{
						"comm": "Явление (совокупность явлений),воздействующее на преступность (порождающее,способствующее или препятствующее ей) - фактор преступности.",
						"ans": "Явление (совокупность явлений),воздействующее на преступность (порождающее,способствующее или препятствующее ей)",
						"score": -5
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let kpp_1_7 = {
	"name": "kpp_1_7",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Основы криминологического прогнозирования и программирования",
	"data": {
		"questions": [
			{
				"qst": "Выберите правильное определение документа под названием «Программа борьбы с преступностью»",
				"correct_ans": [
					{
						"ans": "Документ, определяющий систему мер борьбы с преступностью посредством указания задач, средств, способов, этапов механизма реализации соответствующих мер системы, а также показатели ожидаемых результатов",
						"score": 10
					}
				],
				"wrong_ans": [
					{
						"comm": "Перечень вопросов, подлежащих изучению в процессе анализа уголовного дела - программа изучения уголовного дела.",
						"ans": "Перечень вопросов, подлежащих изучению в процессе анализа уголовного дела",
						"score": -5
					},
					{
						"comm": "Ответ неточный. Программа борьбы с преступностью - документ, определяющий систему мер борьбы с преступностью посредством указания задач, средств, способов, этапов механизма реализации соответствующих мер системы, а также показатели ожидаемых результатов.",
						"ans": "Документ, определяющий систему мер борьбы с преступностью посредством указания задач, этапов механизма реализации соответствующих мер системы, а также показатели ожидаемых результатов",
						"score": 0
					},
					{
						"comm": "Научно обоснованное вероятностное суждение о будущем состоянии, тенденциях, периодах развития преступности, личности преступника, факторов, последствий и мер борьбы с преступностью - криминологический прогноз.",
						"ans": "Научно обоснованное вероятностное суждение о будущем состоянии, тенденциях, периодах развития преступности, личности преступника, факторов, последствий и мер борьбы с преступностью",
						"score": -5
					},
					{
						"comm": "Ответ неточный. Программа борьбы с преступностью - документ, определяющий систему мер борьбы с преступностью посредством указания задач, средств, способов, этапов механизма реализации соответствующих мер системы, а также показатели ожидаемых результатов.",
						"ans": "Документ, определяющий систему мер борьбы с преступностью посредством указания задач, средств, способов, этапов механизма реализации соответствующих мер системы",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let kpp_1_1 = {
	"name": "kpp_1_1",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Основы криминологического прогнозирования и программирования",
	"data": {
		"questions": [
			{
				"qst": "Что такое криминологическая прогностика?",
				"correct_ans": [
					{
						"ans": "Отрасль криминологии, изучающая закономерности составления прогноза состояния и динамики преступности и отдельных ее свойств, личности преступника, факторов, мер профилактики и последствия преступности",
						"score": 10
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ неточный. Криминологическая прогностика - отрасль криминологии, изучающая закономерности составления прогноза состояния и динамики преступности и отдельных ее свойств, личности преступника, факторов, мер профилактики и последствий преступности.",
						"ans": "Отрасль криминологии, изучающая закономерности составления прогноза состояния преступности, личности преступника, причин и условий преступности, системы мер борьбы с преступностью, последствия преступности",
						"score": 0
					},
					{
						"comm": "Ответ неточный. Криминологическая прогностика - отрасль криминологии, изучающая закономерности составления прогноза состояния и динамики преступности и отдельных ее свойств, личности преступника, факторов, мер профилактики и последствия преступности.",
						"ans": "Отрасль криминологии, изучающая закономерности составления прогноза динамики преступности, личности преступника, причин и условий преступности, систему мер борьбы с преступностью, последствий преступности и отдельных их свойств",
						"score": 0
					},
					{
						"comm": "Отрасль криминологии, изучающая закономерности разработки программ (планов) борьбы с преступностью, ее отдельными родами и видами - криминологическое программирование.",
						"ans": "Отрасль криминологии, изучающая закономерности разработки программ (планов) борьбы с преступностью, ее отдельными родами и видами",
						"score": -5
					},
					{
						"comm": "Отрасль криминологии, изучающая семейно-бытовые проявления преступности, ее причины и условия, последствия преступности, личность преступника и специфическую систему мер борьбы с преступностью в семейном быту - криминофамилистика.",
						"ans": "Отрасль криминологии, изучающая семейно-бытовые проявления преступности, ее причины и условия, последствия преступности, личность преступника и специфическую систему мер борьбы с преступностью в семейном быту",
						"score": -5
					},
					{
						"comm": "Отрасль криминологии, изучающая личность жертвы преступления и ее роль в механизме преступного поведения - криминологическая виктимология.",
						"ans": "Отрасль криминологии, изучающая личность жертвы преступления и ее роль в механизме преступного поведения",
						"score": -5
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let kpp_1_8 = {
	"name": "kpp_1_8",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Основы криминологического прогнозирования и программирования",
	"data": {
		"questions": [
			{
				"qst": "Что из себя представляется содержимое программы борьбы с преступностью?",
				"correct_ans": [
					{
						"ans": "Упорядоченное расположение частей и элементов соответствующей программы, включающих: 1) концепцию; 2) организационно - правовое обеспечение; 3) кадровое обеспечение; 4) подсистему мер борьбы с отдельными видами преступлений и обуславливающими их негативными социальными явлениями; 5) участие негосударственных объединений в борьбе с преступностью; 6) правовое информирование населения в сфере борьбы с преступностью; 7) финансирование программы; 8) сроки реализации программы; 9) контроль за реализацией программы",
						"score": 10
					}
				],
				"wrong_ans": [
					{
						"comm": "Внутреннее строение преступности, характеризующееся соотношением отдельных ее типов, родов, видов или разновидностей - структура преступности.",
						"ans": "Внутреннее строение преступности, характеризующееся соотношением отдельных ее типов, родов, видов или разновидностей",
						"score": -5
					},
					{
						"comm": "Ответ неточный. Структура программы борьбы с преступностью - упорядоченное расположение частей и элементов соответствующей программы, включающих: 1) концепцию; 2) организационно - правовое обеспечение; 3) кадровое обеспечение; 4) подсистему мер борьбы с отдельными видами преступлений и обуславливающими их негативными социальными явлениями; 5) участие негосударственных объединений в борьбе с преступностью; 6) правовое информирование населения в сфере борьбы с преступностью; 7) финансирование программы; 8) сроки реализации программы; 9) контроль за реализацией программы.",
						"ans": "Упорядоченное расположение частей и элементов соответствующей программы, включающих: 1) концепцию; 2) организационно - правовое обеспечение; 3) кадровое обеспечение; 4) подсистему мер борьбы с отдельными видами преступлений и обуславливающими их негативными социальными явлениями; 5) участие негосударственных объединений в борьбе с преступностью; 6) правовое информирование населения в сфере борьбы с преступностью; 7) финансирование программы; 8) сроки реализации программы",
						"score": 0
					},
					{
						"comm": "Ответ неточный. Структура программы борьбы с преступностью - упорядоченное расположение частей и элементов соответствующей программы, включающих: 1) концепцию; 2) организационно - правовое обеспечение; 3) кадровое обеспечение; 4) подсистему мер борьбы с отдельными видами преступлений и обуславливающими их негативными социальными явлениями; 5) участие негосударственных объединений в борьбе с преступностью; 6) правовое информирование населения в сфере борьбы с преступностью; 7) финансирование программы; 8) сроки реализации программы; 9) контроль за реализацией программы.",
						"ans": "Упорядоченное расположение частей и элементов соответствующей программы, включающих: 1) концепцию; 2) организационно - правовое обеспечение; 3) кадровое обеспечение; 4) подсистему мер борьбы с отдельными видами преступлений и обуславливающими их негативными социальными явлениями; 5) участие негосударственных объединений в борьбе с преступностью; 6) правовое информирование населения в сфере борьбы с преступностью; 7) сроки реализации программы; 8) контроль за реализацией программы",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let kpp_1_6 = {
	"name": "kpp_1_6",
	"descriprion": "type2",
	"theme": "theme1",
	"title": "Основы криминологического прогнозирования и программирования",
	"data": {
		"questions": [
			{
				"qst": "Криминологическое программирование — это ...",
				"correct_ans": [
					{
						"ans": "Отрасль криминологии, изучающая закономерности разработки программ (планов) борьбы с преступностью, ее отдельными родами и видами",
						"score": 10
					}
				],
				"wrong_ans": [
					{
						"comm": "Отрасль криминологии, изучающая закономерности составления прогноза состояния и динамики преступности и отдельных ее свойств, личности преступника, факторов, мер борьбы и последствий преступности - криминологическая прогностика.",
						"ans": "Отрасль криминологии, изучающая закономерности составления прогноза состояния и динамики преступности и отдельных ее свойств, личности преступника, факторов, мер борьбы и последствий преступности",
						"score": -5
					},
					{
						"comm": "Отрасль криминологии, изучающая преступность и результаты борьбы с ней как массовые социальные явления - уголовная статистика.",
						"ans": "Отрасль криминологии, изучающая преступность и результаты борьбы с ней как массовые социальные явления",
						"score": -5
					},
					{
						"comm": "Ответ неточный. Криминологическое программирование - отрасль криминологии, изучающая закономерности разработки программ (планов) борьбы с преступностью, ее отдельными родами и видами.",
						"ans": "Отрасль криминологии, изучающая закономерности борьбы с преступностью, ее отдельными родами и видами",
						"score": 0
					},
					{
						"comm": "Отрасль криминологии, изучающая преступность, ее причины и условия, личность преступника , специфическую систему мер борьбы с преступностью и последствия преступности в местах лишения свободы - криминопенология.",
						"ans": "Отрасль криминологии, изучающая преступность, ее причины и условия, личность преступника, специфическую систему мер борьбы с преступностью и последствия преступности в местах лишения свободы",
						"score": -5
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let kpp_2_5 = {
	"name": "kpp_2_5",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Виды и методы криминологического прогнозирования и программирования",
	"data": {
		"questions": [
			{
				"qst": "Выберите правильное утверждение:",
				"correct_ans": [
					{
						"ans": "Срок действия программы зависит от того, какой вид прогнозирования был применен",
						"score": 2
					}
				],
				"wrong_ans": [
					{
						"comm": "Вид программы борьбы с преступностью по сроку действия определяется в соответствии с применяемым видом прогнозирования.",
						"ans": "Сроки действия программы борьбы с преступностью определяется разными факторами и не зависят от вида прогнозирования",
						"score": -1
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let kpp_2_8 = {
	"name": "kpp_2_8",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Виды и методы криминологического прогнозирования и программирования",
	"data": {
		"questions": [
			{
				"qst": "Выберите правильно определение методики криминологического прогнозирования",
				"correct_ans": [
					{
						"ans": "Совокупность приемов и правил использования одного или нескольких методов криминологического прогнозирования",
						"score": 2
					}
				],
				"wrong_ans": [
					{
						"comm": "Способ изучения объекта криминологического прогнозирования, направленный на составление соответствующего прогноза - метод криминологического прогнозирования.",
						"ans": "Способ изучения объекта криминологического прогнозирования, направленный на составление соответствующего прогноза",
						"score": -1
					},
					{
						"comm": "Ответ неточный. Методика криминологического прогнозирования - совокупность приемов и правил использования одного или нескольких методов криминологического прогнозирования.",
						"ans": "Использование одного или нескольких методов криминологического прогнозирования",
						"score": 0
					},
					{
						"comm": "Свойство преступности, выражающееся в способности нанесения совокупности общественных отношений существенного ущерба - общественная опасность преступности.",
						"ans": "Свойство преступности, выражающееся в способности нанесения совокупности общественных отношений существенного ущерба",
						"score": -1
					},
					{
						"comm": "Ответ неточный. Методика криминологического прогнозирования - совокупность приемов и правил использования одного или нескольких методов криминологического прогнозирования.",
						"ans": "Совокупность приемов и правил использования одного метода криминологического прогнозирования",
						"score": 0
					},
					{
						"comm": "Изменение преступности во времени - динамика преступности.",
						"ans": "Изменение преступности во времени",
						"score": -1
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let kpp_2_6 = {
	"name": "kpp_2_6",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Виды и методы криминологического прогнозирования и программирования",
	"data": {
		"questions": [
			{
				"qst": "Выберите правильное утверждение",
				"correct_ans": [
					{
						"ans": "Существуют следующие вид программ борьбы с преступностью: 1) планы борьбы с преступностью; 2) программы по усилению борьбы с преступностью; 3) программы-декларации",
						"score": 2
					}
				],
				"wrong_ans": [
					{
						"comm": "Программы борьбы с преступностью, по степени жесткости программируемых мер различаются на планы борьбы с преступностью (очень жесткие), программы по усилению борьбы с преступностью (полужесткие), программы - декларации (заявление о намереньях) .",
						"ans": "Программы борьбы с преступностью, по степени жесткости программируемых мер не различаются",
						"score": -1
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let kpp_2_4 = {
	"name": "kpp_2_4",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Виды и методы криминологического прогнозирования и программирования",
	"data": {
		"questions": [
			{
				"qst": "Какие бывают программы борьбы с преступностью (по масштабу применения)?",
				"correct_ans": [
					{
						"ans": "- объектовые; - локальные; - региональные; - федеральные",
						"score": 2
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ неточный. Виды программ борьбы с преступностью (по масштабу применения): 1) объектовые; 2) локальные; 3) региональные; 4) федеральные.",
						"ans": "- локальные; - региональные; - федеральные",
						"score": 0
					},
					{
						"comm": "Ответ неточный. Виды программ борьбы с преступностью (по масштабу применения): 1) объектовые; 2) локальные; 3) региональные; 4) федеральные.",
						"ans": "- объектовые; - региональные ; - федеральные",
						"score": 0
					},
					{
						"comm": "Ответ неточный. Виды программ борьбы с преступностью (по масштабу применения): 1) объектовые; 2) локальные; 3) региональные; 4) федеральные.",
						"ans": "- региональные; - федеральные",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let kpp_2_1 = {
	"name": "kpp_2_1",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Виды и методы криминологического прогнозирования и программирования",
	"data": {
		"questions": [
			{
				"qst": "Выберите вариант, в котором правильно перечислены виды криминологического прогноза (по продолжительности периода упреждения)",
				"correct_ans": [
					{
						"ans": "- оперативный (до 1 мес.); - краткосрочный (от 1 мес. до 1 года); - среднесрочный (от 1года до 5 лет); - долгосрочный (от 5 года до 15 лет); - дальнесрочный ( свыше 15 лет)",
						"score": 2
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ неточный. Виды криминологического прогноза: - по продолжительности периода упреждения. 1) оперативный (до 1 мес. ); 2) краткосрочный (от 1 мес. до 1 года); 3) среднесрочный (от 1года до 5 лет); 4) долгосрочный (от 5 года до 15 лет); 5) дальнесрочный ( свыше 15 лет).",
						"ans": "- оперативный (до 1 мес.); - краткосрочный (от 1 мес. до 1 года); - долгосрочный (от 1 года до 15 лет); - дальнесрочный ( свыше 15 лет)",
						"score": 0
					},
					{
						"comm": "Ответ неточный. Виды криминологического прогноза: - по продолжительности периода упреждения. 1) оперативный (до 1 мес. ); 2) краткосрочный (от 1 мес. до 1 года); 3) среднесрочный (от 1года до 5 лет); 4) долгосрочный (от 5 года до 15 лет); 5) дальнесрочный ( свыше 15 лет).",
						"ans": "- оперативный (до 1 мес.); - краткосрочный (от 1 мес. до 1 года); - среднесрочный (от 1 года до 15 лет); - дальнесрочный ( свыше 15 лет)",
						"score": 0
					},
					{
						"comm": "Ответ неточный. Виды криминологического прогноза: - по продолжительности периода упреждения. 1) оперативный (до 1 мес. ); 2) краткосрочный (от 1 мес. до 1 года); 3) среднесрочный (от 1года до 5 лет); 4) долгосрочный (от 5 года до 15 лет); 5) дальнесрочный ( свыше 15 лет).",
						"ans": "- оперативный (до 6 мес.); - краткосрочный (от 6 мес. до 1 года); - среднесрочный (от 1года до 5 лет); - долгосрочный (от 5 года до 15 лет); - дальнесрочный ( свыше 15 лет)",
						"score": 0
					},
					{
						"comm": "Ответ неточный. Виды криминологического прогноза: - по продолжительности периода упреждения. 1) оперативный (до 1 мес. ); 2) краткосрочный (от 1 мес. до 1 года); 3) среднесрочный (от 1года до 5 лет); 4) долгосрочный (от 5 года до 15 лет); 5) дальнесрочный ( свыше 15 лет).",
						"ans": "- оперативный (до 1 мес.); - краткосрочный (от 1 мес. до 1 года); - среднесрочный (от 1года до 5 лет); - долгосрочный (от 5 года до 10 лет); - дальнесрочный ( свыше 10 лет)",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let kpp_2_11 = {
	"name": "kpp_2_11",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Виды и методы криминологического прогнозирования и программирования",
	"data": {
		"questions": [
			{
				"qst": "Фактографический метод криминологического прогнозирования — это ...",
				"correct_ans": [
					{
						"ans": "Метод, источником которого являются зафиксированные в документах факты",
						"score": 2
					}
				],
				"wrong_ans": [
					{
						"comm": "Метод, основанный на экспертной оценке - экспертный метод криминологического прогнозирования.",
						"ans": "Метод, основанный на экспертной оценке",
						"score": -1
					},
					{
						"comm": "Совокупность свойств и отношений, характеризующих абстрактного нарушителя уголовно - правового запрета - личность преступника.",
						"ans": "Совокупность свойств и отношений, характеризующих абстрактного нарушителя уголовно - правового запрета",
						"score": -1
					},
					{
						"comm": "Условное разделение свойств и отношений, характеризующих абстрактного нарушителя уголовного закона на демографические, социально - ролевые, правовые, психологические, физиологические и иные значимые с криминологической точки зрения однородные группы свойств и отношений - структура личности преступника.",
						"ans": "Условное разделение свойств и отношений, характеризующих абстрактного нарушителя уголовного закона на демографические, социально - ролевые, правовые, психологические, физиологические и иные значимые с криминологической точки зрения однородные группы свойств и отношений",
						"score": -1
					},
					{
						"comm": "Ответ неточный. Фактографический метод криминологического прогнозирования - метод источником которого являются зафиксированные в документах факты.",
						"ans": "Метод источником которого являются факты",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let kpp_2_2 = {
	"name": "kpp_2_2",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Виды и методы криминологического прогнозирования и программирования",
	"data": {
		"questions": [
			{
				"qst": "Какие существуют виды криминологического прогноза (по объекту прогнозирования)?",
				"correct_ans": [
					{
						"ans": "- преступности; - личности преступника; - факторов преступности; - последствий преступности; - мер борьбы с преступностью",
						"score": 2
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ неточный. Виды криминологического прогноза (по объекту прогнозирования): 1) преступности; 2) личности преступника; 3) факторов преступности; 4) последствий преступности; 5) мер борьбы с преступностью.",
						"ans": "- преступности; - личности преступника; - факторов преступности; - мер борьбы с преступностью",
						"score": 0
					},
					{
						"comm": "Ответ неточный. Виды криминологического прогноза (по объекту прогнозирования): 1) преступности; 2) личности преступника; 3) факторов преступности; 4) последствий преступности; 5) мер борьбы с преступностью.",
						"ans": "- преступности; - личности преступника; - последствий преступности; - мер борьбы с преступностью",
						"score": 0
					},
					{
						"comm": "Ответ неточный. Виды криминологического прогноза (по объекту прогнозирования): 1) преступности; 2) личности преступника; 3) факторов преступности; 4) последствий преступности; 5) мер борьбы с преступностью.",
						"ans": "- преступности; - личности преступника; - факторов преступности; - последствий преступности; - изменений законодательства",
						"score": 0
					},
					{
						"comm": "Естественная, искусственная, \"пограничная\" - виды латентной преступности.",
						"ans": "- естественный; - искусственный; - пограничный",
						"score": -1
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let kpp_2_15 = {
	"name": "kpp_2_15",
	"descriprion": "type2",
	"theme": "theme2",
	"title": "Виды и методы криминологического прогнозирования и программирования",
	"data": {
		"questions": [
			{
				"qst": "Дайте определение метода экстраполяции",
				"correct_ans": [
					{
						"ans": "Математический метод криминологического прогнозирования основанный на перенесении количественных закономерностей развития объекта в прошлом на будущий период",
						"score": 2
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответ неточный. Метод экстраполяции - математический метод криминологического прогнозирования основанный на перенесении количественных закономерностей развития объекта в прошлом на будущий период.",
						"ans": "Метод криминологического прогнозирования основанный на перенесении количественных закономерностей развития объекта в прошлом на будущий период",
						"score": 0
					},
					{
						"comm": "Метод криминологического прогнозирования основанный на внезапном прояснении сознания - эвристический метод.",
						"ans": "Метод криминологического прогнозирования основанный на внезапном прояснении сознания",
						"score": -1
					},
					{
						"comm": "Метод криминологического прогнозирования основанный на перенесении качественных закономерностей развития объекта в прошлом на будущий период - метод исторической аналогии.",
						"ans": "Метод криминологического прогнозирования основанный на перенесении качественных закономерностей развития объекта в прошлом на будущий период",
						"score": -1
					},
					{
						"comm": "Метод криминологического прогнозирования основанный на выявлении согласованной оценки экспертной группы посредством независимого опроса каждого эксперта в несколько туров, при условии сообщения в каждом последующем туре результатов опроса в предыдущем с целью получения дополнительного обоснования последней оценки - дельфийский метод.",
						"ans": "Метод криминологического прогнозирования основанный на выявлении согласованной оценки экспертной группы посредством независимого опроса каждого эксперта в несколько туров, при условии сообщения в каждом последующем туре результатов опроса в предыдущем с целью получения дополнительного обоснования последней оценки",
						"score": -1
					},
					{
						"comm": "Ответ неточный. Метод экстраполяции - математический метод криминологического прогнозирования основанный на перенесении количественных закономерностей развития объекта в прошлом на будущий период.",
						"ans": "Математический метод криминологического прогнозирования основанный на перенесении закономерностей развития объекта в прошлом на будущий период",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let kpp_3_1 = {
	"name": "kpp_3_1",
	"descriprion": "type2",
	"theme": "theme3",
	"title": "Практическое применение",
	"data": {
		"questions": [
			{
				"qst": "Кто является ответственнным исполнителем Государственной программы Российской Федерации «Обеспечение общественного порядка и противодействие преступности»?",
				"correct_ans": [
					{
						"ans": "МВД РФ",
						"score": 3
					}
				],
				"wrong_ans": [
					{
						"comm": "Ответственным исполнителем является МВД РФ.",
						"ans": "Министерство обороны РФ",
						"score": -1
					},
					{
						"comm": "Ответственным исполнителем является МВД РФ.",
						"ans": "МВД РФ, Минюст РФ, Верховный суд РФ, Генпрокуратура РФ, ФСБ РФ, ГТК РФ, Госналогслужба РФ",
						"score": -1
					},
					{
						"comm": "Ответственным исполнителем является МВД РФ.",
						"ans": "Правительство РФ",
						"score": -1
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

